module.exports = __webpack_public_path__ + "static/Gotham-Book-29cf1d4c94d1f1d0837c83907c0b1c52.woff2";